import { render, staticRenderFns } from "./Game11_fd.vue?vue&type=template&id=5c037a4a&scoped=true&"
import script from "./Game11_fd.vue?vue&type=script&lang=js&"
export * from "./Game11_fd.vue?vue&type=script&lang=js&"
import style0 from "./Game11_fd.vue?vue&type=style&index=0&id=5c037a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c037a4a",
  null
  
)

export default component.exports